/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_StackInputs */

const en_hero_stack = /** @type {(inputs: Hero_StackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stack: TypeScript · React · Node.js`)
};

const ar_hero_stack = /** @type {(inputs: Hero_StackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التقنيات: TypeScript · React · Node.js`)
};

const bn_hero_stack = /** @type {(inputs: Hero_StackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্ট্যাক: TypeScript · React · Node.js`)
};

const de_hero_stack = /** @type {(inputs: Hero_StackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technologien: TypeScript · React · Node.js`)
};

const es_hero_stack = /** @type {(inputs: Hero_StackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tecnologías: TypeScript · React · Node.js`)
};

const fr_hero_stack = /** @type {(inputs: Hero_StackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technologies : TypeScript · React · Node.js`)
};

const pt_hero_stack = /** @type {(inputs: Hero_StackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tecnologias: TypeScript · React · Node.js`)
};

const zh_hero_stack = /** @type {(inputs: Hero_StackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`堆栈：TypeScript · React · Node.js`)
};

const tr_hero_stack = /** @type {(inputs: Hero_StackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yığın: TypeScript · React · Node.js`)
};

const ru_hero_stack = /** @type {(inputs: Hero_StackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стек: TypeScript · React · Node.js`)
};

const pl_hero_stack = /** @type {(inputs: Hero_StackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stos: TypeScript · React · Node.js`)
};

/**
* | output |
* | --- |
* | "Stack: TypeScript · React · Node.js" |
*
* @param {Hero_StackInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const hero_stack = /** @type {((inputs?: Hero_StackInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_StackInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_hero_stack(inputs)
	if (locale === "bn") return bn_hero_stack(inputs)
	if (locale === "de") return de_hero_stack(inputs)
	if (locale === "es") return es_hero_stack(inputs)
	if (locale === "fr") return fr_hero_stack(inputs)
	if (locale === "pt") return pt_hero_stack(inputs)
	if (locale === "zh") return zh_hero_stack(inputs)
	if (locale === "tr") return tr_hero_stack(inputs)
	if (locale === "ru") return ru_hero_stack(inputs)
	if (locale === "pl") return pl_hero_stack(inputs)
	return en_hero_stack(inputs)
});